export default __webpack_public_path__ + "static/media/ticket-icon-red.55760fc0.svg";